export enum RockPaperScissorsChoice {
  Rock,
  Paper,
  Scissors
}

export enum RockPaperScissorsResult {
  Won,
  Lost,
  Draw
}
